import CModule from 'cache-service-cache-module';

var raceScheduleCache = new CModule({
	type: 'race-schedule-cache'
});

export default raceScheduleCache;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/store/Cache.js
 **/